import { useState } from 'react';

import type { HoursSubmissionView } from '../viewModel';

/** The prototype's threshold for clamping a description to two lines. */
const CLAMP_AFTER_CHARS = 80;

/**
 * The work description, clamped to two lines past the prototype's threshold,
 * then the notes. A deemed approval's `resolution` is a machine code
 * (`no_response_after_5d`), not a note, so it is never printed: the status
 * caption says it in words instead.
 */
export default function HoursDescriptionCell({ row }: { row: HoursSubmissionView }): JSX.Element {
  const [expanded, setExpanded] = useState(false);
  const description = row.workDescription ?? '';
  const clampable = description.length > CLAMP_AFTER_CHARS;
  const humanResolution = row.approvedAutomatically ? null : row.resolution;

  return (
    <div className="flex flex-col items-start gap-4">
      {description ? (
        <span className={`text-on-surface body-2 ${clampable && !expanded ? 'line-clamp-2' : ''}`}>
          {description}
        </span>
      ) : null}
      {clampable ? (
        <button
          type="button"
          aria-expanded={expanded}
          onClick={() => setExpanded(!expanded)}
          className="inline-flex min-h-[44px] items-center text-brand-primary body-2 hover:underline focus-visible:underline focus-visible:outline-none"
        >
          {expanded ? 'Show less' : 'Show more'}
        </button>
      ) : null}
      {row.disputeNote ? (
        <p className="text-on-surface-muted body-2">Dispute: {row.disputeNote}</p>
      ) : null}
      {humanResolution ? (
        <p className="text-on-surface-muted body-2">Resolution: {humanResolution}</p>
      ) : null}
    </div>
  );
}
